import { render, staticRenderFns } from "./ShapeEditorToolbar.vue?vue&type=template&id=51ae5981&scoped=true&"
import script from "./ShapeEditorToolbar.vue?vue&type=script&lang=js&"
export * from "./ShapeEditorToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ShapeEditorToolbar.vue?vue&type=style&index=0&id=51ae5981&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae5981",
  null
  
)

export default component.exports